webModule.controller('showcaseLiteIntroController',
    ['$scope','$rootScope', '$location', '$window', 'routes', 'AppSettings','userAuthenticateService', 'imSessionVarsService',
        function ($scope, $rootScope, $location, window, routes, AppSettings, userAuthenticateService, imSessionVarsService) {

        $scope.showcaseUrl = null;

        $scope.init = function(){
            $scope.showcaseUrl = AppSettings.showcaseUrl + '/sso-redirect?imtk=' +
                userAuthenticateService.getUserToken() + '&imdlr=' +
                imSessionVarsService.getCurrentDealerIMId() + '&appmd=SHOWLITE';
        }
        $scope.init();
    }]);
